import { useState, useEffect } from 'react';
import { Card, CardContent, Typography, CircularProgress, IconButton } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { getDefinition } from '../services/backend';
import ReactMarkdown from 'react-markdown';
const Dictionary = ({ word, language, user_id, onClose }) => {
  const [definition, setDefinition] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);



  const fetchAiDefinition = async () => {
    setLoading(true);
    setError(null);
    try {
      const response = await getDefinition(word, language, user_id);
      setDefinition(response.data);
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (!word) return;
    fetchAiDefinition();
  }, [word]);

  if (!word) return null;

  return (
    <Card sx={{ position: 'fixed', bottom: { xs: 0, md: 20 }, right: { xs: 0, md: 20 }, width: { xs: '100%', md: 'auto' }, maxWidth: 600, zIndex: 1000, overflow: 'auto', maxHeight: '80vh' }}>
      <CardContent sx={{ position: 'relative', paddingBottom: '40px' }}>
        <IconButton
          onClick={onClose}
          sx={{ position: 'absolute', right: 8, top: 8 }}
          aria-label="close"
        >
          <CloseIcon />
        </IconButton>
        
        {loading ? (
          <CircularProgress size={20} />
        ) : error ? (
          <>
          <Typography variant="h6" gutterBottom>
              {word}
          </Typography>
          <Typography color="error">{error}</Typography>
          </>
        ) : definition && (
          <div style={{ overflowY: 'auto', maxHeight: 'calc(80vh - 40px)' }}>
            <ReactMarkdown>{definition}</ReactMarkdown>
          </div>
        )}
      </CardContent>
    </Card>
  );
};

export default Dictionary; 

